var map = {
	"./Ellipse-1.png": 19982,
	"./Ellipse-2.png": 90341,
	"./Group 13153.png": 69038,
	"./Group 1813.png": 79068,
	"./aero-img.png": 98229,
	"./aulascadu.jpg": 67025,
	"./ban-bg.png": 99938,
	"./bank-image.png": 88314,
	"./banner-background-img-1.png": 41781,
	"./banner-background-img-2.png": 5054,
	"./banner-img (2).png": 47279,
	"./banner-img-1.png": 15410,
	"./banner-img-2.png": 80553,
	"./banner-img-3.png": 25728,
	"./banner-img-4.png": 84383,
	"./banner-img-5.png": 6294,
	"./banner-img.png": 25676,
	"./banner.png": 80758,
	"./become-01.png": 86255,
	"./become-02.png": 64788,
	"./best-course-img-1.jpg": 83698,
	"./best-course-img-2.jpg": 37853,
	"./best-course-img-3.jpg": 69760,
	"./bg-banner-01.png": 12052,
	"./bg-banner-02.png": 33519,
	"./bg-banner.png": 42274,
	"./bg-inner.jpeg": 18123,
	"./bg-inner.png": 68170,
	"./bg-inner2.jpg": 86598,
	"./bg/banner-vector.svg": 92816,
	"./bg/bg-2.png": 3634,
	"./bg/bg-3.png": 25179,
	"./bg/bg-footer.jpg": 47051,
	"./bg/breadcrumb-bar.png": 48825,
	"./bg/footer-left.svg": 79047,
	"./bg/footer-right.svg": 78338,
	"./bg/home-left.png": 2137,
	"./bg/home-main.png": 92609,
	"./bg/home-middle.png": 13165,
	"./bg/home-right-bottom.png": 23624,
	"./bg/home-right.png": 15074,
	"./bg/instructor-vector-left.svg": 33853,
	"./bg/instructor-vector-right.svg": 3552,
	"./bg/map-user.png": 85172,
	"./bg/map.png": 6098,
	"./bg/master-vector-left.svg": 30146,
	"./bg/patter-one.png": 465,
	"./bg/pattern-01.png": 47876,
	"./bg/pattern-02.png": 33151,
	"./bg/pattern-03.png": 79350,
	"./bg/pattern-04.png": 29321,
	"./bg/pattern-05.svg": 96180,
	"./bg/pattern-06.svg": 44391,
	"./bg/pattern-left.png": 93174,
	"./bg/pattern-right.png": 20011,
	"./bg/profile-bg.jpg": 17543,
	"./bg/quote.svg": 74414,
	"./bg/shape-1.png": 48433,
	"./bg/shape-2.png": 88538,
	"./bg/shape-owel.svg": 99571,
	"./bg/skill-icon-01.png": 61409,
	"./bg/skill-icon-02.png": 12426,
	"./bg/skill-icon-03.png": 63187,
	"./bg/slide-left.svg": 63941,
	"./bg/vector-layer-one.png": 41740,
	"./bg/vector-layer-three.png": 23532,
	"./bg/vector-layer-two.png": 12014,
	"./blog-banner.jpg": 51133,
	"./blog/blog-01.jpg": 63373,
	"./blog/blog-02.jpg": 94146,
	"./blog/blog-03.jpg": 85855,
	"./blog/blog-04.jpg": 7572,
	"./blog/blog-05.jpg": 79377,
	"./blog/blog-06.jpg": 63526,
	"./blog/blog-07.jpg": 53635,
	"./blog/blog-08.jpg": 96024,
	"./blog/blog-09.jpg": 341,
	"./blog/blog-10.jpg": 82255,
	"./blog/blog-11.jpg": 9874,
	"./blog/blog-12.jpg": 19773,
	"./blog/blog-13.jpg": 68640,
	"./blog/blog-14.jpg": 51475,
	"./blog/blog-15.jpg": 65014,
	"./blog/blog-16.jpg": 35361,
	"./blog/blog-17.jpg": 57316,
	"./blog/blog-18.jpg": 31735,
	"./blog/blog-19.jpg": 67898,
	"./blog/blog-20.jpg": 52938,
	"./blog/blog-21.jpg": 48743,
	"./blog/blog-22.jpg": 15896,
	"./blog/blog-23.jpg": 77077,
	"./blog/blog-24.jpg": 40014,
	"./blog/blog-img-01.jpg": 86347,
	"./blog/blog-img-02.jpg": 94364,
	"./blog/blog-img-03.jpg": 15417,
	"./blur.png": 29635,
	"./cadu.jpeg": 61830,
	"./caduceus-logo.png": 15721,
	"./caduceus.png": 50153,
	"./caduceus/address-icon.png": 24548,
	"./caduceus/course/course-01.jpg": 51953,
	"./caduceus/course/course-01.svg": 70765,
	"./caduceus/course/course-02.jpg": 94182,
	"./caduceus/course/course-02.svg": 22414,
	"./caduceus/course/course-03.jpg": 97616,
	"./caduceus/course/course-03.svg": 50847,
	"./caduceus/course/course-04.jpg": 44080,
	"./caduceus/course/course-04.svg": 84960,
	"./caduceus/course/course-05.jpg": 87533,
	"./caduceus/course/course-06.jpg": 39042,
	"./caduceus/course/course-07.jpg": 75391,
	"./caduceus/course/course-08.jpg": 31292,
	"./caduceus/course/course-09.jpg": 45017,
	"./caduceus/course/course-10.jpg": 81523,
	"./caduceus/course/course-11.jpg": 9910,
	"./caduceus/course/course-12.jpg": 59521,
	"./caduceus/course/course-13.jpg": 81476,
	"./caduceus/course/course-14.jpg": 7855,
	"./caduceus/course/course-15.jpg": 31474,
	"./caduceus/course/course-16.jpg": 50429,
	"./caduceus/course/course-17.jpg": 41216,
	"./caduceus/course/course-20.jpg": 88238,
	"./caduceus/course/course-21.jpg": 66283,
	"./caduceus/course/course-22.jpg": 81628,
	"./caduceus/course/course-23.jpg": 68505,
	"./caduceus/course/course-24.jpg": 31786,
	"./caduceus/course/course-25.jpg": 99527,
	"./caduceus/course/course-26.jpg": 19544,
	"./caduceus/course/course-27.jpg": 23861,
	"./caduceus/course/course-28.jpg": 87046,
	"./caduceus/course/course-29.jpg": 77155,
	"./caduceus/course/course-30.jpg": 14021,
	"./caduceus/course/courses-01.jpg": 95852,
	"./caduceus/course/courses-02.jpg": 38651,
	"./caduceus/course/courses-03.jpg": 67518,
	"./caduceus/course/courses-04.jpg": 78341,
	"./caduceus/course/courses-05.jpg": 15976,
	"./caduceus/course/courses-06.jpg": 50199,
	"./caduceus/course/featured-course-01.jpg": 41370,
	"./caduceus/course/featured-course-02.jpg": 45573,
	"./caduceus/course/featured-course-03.jpg": 1608,
	"./caduceus/course/featured-course-04.jpg": 99547,
	"./caduceus/course/featured-course-05.jpg": 98238,
	"./caduceus/course/featured-course-06.jpg": 77833,
	"./caduceus/courses-icon.png": 76954,
	"./caduceus/email-icon.png": 52772,
	"./caduceus/instructor-01.jpg": 33527,
	"./caduceus/instructor-02.jpg": 22600,
	"./caduceus/instructor-03.jpg": 50213,
	"./caduceus/instructor-04.jpg": 2878,
	"./caduceus/instructor-bg-banner--.png": 56178,
	"./caduceus/instructor-bg-banner.png": 64080,
	"./caduceus/instructor-course-icon.svg": 95007,
	"./caduceus/instructor-reviews-icon.svg": 8463,
	"./caduceus/instructor-students-icon.svg": 67862,
	"./caduceus/instructor-table-01.jpg": 68362,
	"./caduceus/instructor-table-02.jpg": 94613,
	"./caduceus/instructor-table-03.jpg": 86744,
	"./caduceus/instructor-table-04.jpg": 26539,
	"./caduceus/instructor-table-05.jpg": 48494,
	"./caduceus/phone-icon.png": 34004,
	"./caduceus/profile-avatar.jpg": 48973,
	"./caduceus/review-icon.png": 82854,
	"./caduceus/ttl-stud-icon.png": 80695,
	"./career-img-1.png": 13894,
	"./career-img-2.png": 95101,
	"./categories-icon-01.png": 83390,
	"./categories-icon-02.png": 69141,
	"./categories-icon-03.png": 86252,
	"./categories-icon-04.png": 16419,
	"./categories-icon-05.png": 94842,
	"./categories-icon.png": 86080,
	"./category-bg.png": 29014,
	"./category/category-01.jpg": 48453,
	"./category/category-02.jpg": 25850,
	"./category/category-03.jpg": 89687,
	"./category/category-04.jpg": 8492,
	"./category/category-05.jpg": 46537,
	"./category/category-06.jpg": 3454,
	"./category/category-07.jpg": 34939,
	"./category/category-08.jpg": 26592,
	"./category/category-09.jpg": 77725,
	"./category/category-1.svg": 30123,
	"./category/category-10.jpg": 89511,
	"./category/category-11.jpg": 50506,
	"./category/category-12.jpg": 17845,
	"./category/category-13.jpg": 10584,
	"./category/category-14.jpg": 33419,
	"./category/category-15.jpg": 6958,
	"./category/category-16.jpg": 79449,
	"./category/category-17.jpg": 65724,
	"./category/category-18.jpg": 93471,
	"./category/category-2.svg": 79384,
	"./category/category-3-old.svg": 33757,
	"./category/category-3.svg": 83625,
	"./category/category-4.svg": 54182,
	"./category/category-5.svg": 68567,
	"./category/category-6.svg": 25444,
	"./category/category-7.svg": 76613,
	"./category/category-8.svg": 31970,
	"./certificate-icon.svg": 28331,
	"./chat-img-01.jpg": 82154,
	"./circle-icon.png": 28388,
	"./client/client-01.svg": 40077,
	"./client/client-02.svg": 57102,
	"./client/client-03.svg": 71743,
	"./client/client-04.svg": 54272,
	"./client/client-05.svg": 68657,
	"./cloud-icons.png": 2348,
	"./come-soon.png": 24918,
	"./comma-icon.png": 40817,
	"./company-img-1.png": 76551,
	"./company-img-2.png": 25868,
	"./company-img-3.png": 37493,
	"./company-img-4.png": 69082,
	"./company-img-5.png": 58915,
	"./company-img-6.png": 96936,
	"./cources-icon.svg": 41846,
	"./course-01.png": 62887,
	"./course-02.png": 73471,
	"./course-03.png": 7477,
	"./course-04.png": 55418,
	"./course-arrow.png": 54967,
	"./course-bg.png": 66779,
	"./course-img-1.jpg": 75955,
	"./course-img-2.jpg": 49732,
	"./course-img-3.jpg": 23329,
	"./course/course-01.jpg": 1951,
	"./course/course-01.svg": 7433,
	"./course/course-02.jpg": 87600,
	"./course/course-02.svg": 22970,
	"./course/course-03.jpg": 39821,
	"./course/course-03.svg": 53931,
	"./course/course-04.jpg": 20742,
	"./course/course-04.svg": 49252,
	"./course/course-05.jpg": 80227,
	"./course/course-06.jpg": 34164,
	"./course/course-07.jpg": 48497,
	"./course/course-08.jpg": 77386,
	"./course/course-09.jpg": 33223,
	"./course/course-10.jpg": 68825,
	"./course/course-11.jpg": 24476,
	"./course/course-12.jpg": 49643,
	"./course/course-13.jpg": 70158,
	"./course/course-14.jpg": 7221,
	"./course/course-15.jpg": 46040,
	"./course/course-16.jpg": 78887,
	"./course/course-17.jpg": 83082,
	"./course/course-20.jpg": 12296,
	"./course/course-21.jpg": 39909,
	"./course/course-22.jpg": 60301,
	"./course/course-23.jpg": 34615,
	"./course/course-24.jpg": 74380,
	"./course/course-25.jpg": 88521,
	"./course/course-26.jpg": 97022,
	"./course/course-27.jpg": 17179,
	"./course/course-28.jpg": 91872,
	"./course/course-29.jpg": 43613,
	"./course/course-30.jpg": 6151,
	"./course/courses-01.jpg": 42538,
	"./course/courses-02.jpg": 9877,
	"./course/courses-03.jpg": 2616,
	"./course/courses-04.jpg": 25451,
	"./course/courses-05.jpg": 98990,
	"./course/courses-06.jpg": 55129,
	"./course/featured-course-01.jpg": 32356,
	"./course/featured-course-02.jpg": 16051,
	"./course/featured-course-03.jpg": 60790,
	"./course/featured-course-04.jpg": 1309,
	"./course/featured-course-05.jpg": 92096,
	"./course/featured-course-06.jpg": 58735,
	"./demo.png": 79753,
	"./deposit-01.jpg": 54342,
	"./deposit-01.png": 52354,
	"./deposit-02.jpg": 95761,
	"./deposit-02.png": 66361,
	"./deposit-03.jpg": 98388,
	"./deposit-03.png": 50608,
	"./deposit-04.jpg": 19199,
	"./deposit-04.png": 46479,
	"./deposit.png": 51748,
	"./developer-img-2.jpg": 7911,
	"./developer-img-3.png": 85998,
	"./developer-img.png": 47014,
	"./dotted-square-img.png": 65332,
	"./education-img-1.jpg": 19208,
	"./education-img-2.jpg": 41527,
	"./education.png": 7908,
	"./error-01.png": 66350,
	"./error-02.png": 38149,
	"./error-bg.png": 26305,
	"./error-bg1.png": 11733,
	"./error.png": 70051,
	"./favicon.svg": 45278,
	"./favicon.webp": 98007,
	"./feature-img-1.jpg": 57688,
	"./feature-img-2.jpg": 37671,
	"./feature-img-3.jpg": 69930,
	"./feature-img-4.jpg": 6649,
	"./feature-instructor-img-1.png": 26265,
	"./feature-instructor-img-2.png": 89885,
	"./feature-instructor-img-3.png": 68756,
	"./feature-instructor-img-4.png": 14667,
	"./female-student-img.png": 31164,
	"./figma-icon.png": 20862,
	"./footer-background-img.png": 31358,
	"./footer-logo.png": 60317,
	"./gallery/gallery-1.jpg": 61813,
	"./gallery/gallery-2.jpg": 21322,
	"./gallery/gallery-3.jpg": 33479,
	"./gallery/gallery-4.jpg": 56687,
	"./gallery/gallery-5.jpg": 7065,
	"./gallery/gallery-6.jpg": 8398,
	"./gallery/gallery-7.jpg": 4235,
	"./gallery/gallery-8.jpg": 22480,
	"./gratuate-icon.svg": 40265,
	"./header-background-img.png": 81480,
	"./home-four-vector-left.svg": 18026,
	"./home-four-vector-right.svg": 51713,
	"./home-six-banner.jpg": 44543,
	"./icon-three/award.svg": 26704,
	"./icon-three/building.svg": 41917,
	"./icon-three/career-01.svg": 96721,
	"./icon-three/career-01A.svg": 79442,
	"./icon-three/career-02.svg": 39618,
	"./icon-three/career-02B.svg": 79724,
	"./icon-three/career-03.svg": 43347,
	"./icon-three/career-03C.svg": 95434,
	"./icon-three/career-04.svg": 20780,
	"./icon-three/career-04D.svg": 80408,
	"./icon-three/check-round-1.svg": 5014,
	"./icon-three/check-round-2.svg": 76885,
	"./icon-three/check-round-3.svg": 4276,
	"./icon-three/check-round.svg": 58008,
	"./icon-three/course-01.svg": 44698,
	"./icon-three/course-01A.svg": 60743,
	"./icon-three/course-02.svg": 59785,
	"./icon-three/course-02B.svg": 41449,
	"./icon-three/course-03.svg": 24920,
	"./icon-three/course-03C.svg": 84539,
	"./icon-three/course-04.svg": 44727,
	"./icon-three/course-04D.svg": 89529,
	"./icon-three/ellipse-1.svg": 36391,
	"./icon-three/ellipse-2.svg": 64884,
	"./icon-three/ellipse-3.svg": 90517,
	"./icon-three/email.svg": 22931,
	"./icon-three/search-icon.svg": 4533,
	"./icon-three/student-icon.svg": 42656,
	"./icon-three/student.svg": 9398,
	"./icon-three/time.svg": 19214,
	"./icon-three/winning.svg": 90563,
	"./icon/angry.svg": 82119,
	"./icon/anguish.svg": 44779,
	"./icon/angular-icon.svg": 67076,
	"./icon/award-new.svg": 30254,
	"./icon/award.svg": 72747,
	"./icon/badge.svg": 12841,
	"./icon/become-01.svg": 32033,
	"./icon/become-02.svg": 26994,
	"./icon/book-icon.svg": 62803,
	"./icon/building.svg": 76760,
	"./icon/career-01.svg": 16134,
	"./icon/career-02.svg": 47909,
	"./icon/career-03.svg": 50660,
	"./icon/career-04.svg": 34603,
	"./icon/cart.svg": 13050,
	"./icon/certificate.svg": 17589,
	"./icon/certified-course-icon.svg": 14235,
	"./icon/chapter.svg": 81900,
	"./icon/chart.svg": 57416,
	"./icon/check-circle.svg": 42165,
	"./icon/check-round-1.svg": 38673,
	"./icon/check-round-2.svg": 74626,
	"./icon/check-round-3.svg": 88851,
	"./icon/check-round.svg": 31639,
	"./icon/close-circle.svg": 29761,
	"./icon/cloud-icon-1.svg": 24361,
	"./icon/cloud-icon-2.svg": 56250,
	"./icon/cloud-icon-3.svg": 70859,
	"./icon/cloud-icon-4.svg": 66180,
	"./icon/cloud.svg": 29691,
	"./icon/company-logo-1.svg": 17421,
	"./icon/company-logo-2.svg": 34446,
	"./icon/company-logo-3.svg": 49087,
	"./icon/count-four.svg": 33482,
	"./icon/count-one.svg": 27002,
	"./icon/count-three.svg": 50994,
	"./icon/count-two.svg": 78820,
	"./icon/course-01.svg": 59097,
	"./icon/course-02.svg": 67722,
	"./icon/course-03.svg": 28091,
	"./icon/course-04.svg": 18324,
	"./icon/docker.svg": 89892,
	"./icon/ellipse-1.svg": 79528,
	"./icon/ellipse-2.svg": 30267,
	"./icon/ellipse-3.svg": 69898,
	"./icon/email.svg": 32376,
	"./icon/expert-tutor-icon.svg": 87835,
	"./icon/fb-icon.svg": 37682,
	"./icon/figma.svg": 39764,
	"./icon/github-icon.svg": 75025,
	"./icon/google-icon.svg": 81777,
	"./icon/graduation-hat-icon.svg": 68014,
	"./icon/heart.svg": 17324,
	"./icon/home-search-six.svg": 39813,
	"./icon/icon-01.svg": 25109,
	"./icon/icon-02.svg": 4822,
	"./icon/icon-03.svg": 51687,
	"./icon/icon-04.svg": 49288,
	"./icon/icon-05.svg": 45305,
	"./icon/icon-06.svg": 96010,
	"./icon/icon-07.svg": 64827,
	"./icon/icon-08.svg": 62588,
	"./icon/icon-09.svg": 91133,
	"./icon/icon-1.svg": 84557,
	"./icon/icon-10.svg": 47127,
	"./icon/icon-11.svg": 41798,
	"./icon/icon-12.svg": 89925,
	"./icon/icon-13.svg": 92676,
	"./icon/icon-14.svg": 60267,
	"./icon/icon-15.svg": 66394,
	"./icon/icon-16.svg": 27561,
	"./icon/icon-17.svg": 2200,
	"./icon/icon-18.svg": 12415,
	"./icon/icon-19.svg": 97774,
	"./icon/icon-2.svg": 55438,
	"./icon/icon-20.svg": 56642,
	"./icon/icon-21.svg": 61811,
	"./icon/icon-22.svg": 41056,
	"./icon/icon-23.svg": 77009,
	"./icon/icon-24.svg": 78510,
	"./icon/icon-25.svg": 6943,
	"./icon/icon-26.svg": 27916,
	"./icon/icon-27.svg": 26861,
	"./icon/icon-3.svg": 76543,
	"./icon/icon-4.svg": 17984,
	"./icon/import.svg": 58183,
	"./icon/joing-01.svg": 30665,
	"./icon/joing-02.svg": 15578,
	"./icon/joing-03.svg": 34635,
	"./icon/joing-04.svg": 72484,
	"./icon/key.svg": 61181,
	"./icon/lab-img-1.svg": 21793,
	"./icon/lab-img-10.svg": 95907,
	"./icon/lab-img-11.svg": 41618,
	"./icon/lab-img-2.svg": 40050,
	"./icon/lab-img-3.svg": 89443,
	"./icon/lab-img-4.svg": 61788,
	"./icon/lab-img-5.svg": 73981,
	"./icon/lab-img-6.svg": 61886,
	"./icon/lab-img-7.svg": 24463,
	"./icon/lab-img-8.svg": 66312,
	"./icon/lab-img-9.svg": 48057,
	"./icon/laravel-icon.svg": 56835,
	"./icon/like.svg": 82513,
	"./icon/lock.svg": 99877,
	"./icon/master-skill-icon-1.svg": 4718,
	"./icon/master-skill-icon-2.svg": 33837,
	"./icon/master-skill-icon-3.svg": 54124,
	"./icon/master-skill-icon-4.svg": 38163,
	"./icon/message-text.svg": 51191,
	"./icon/messages.svg": 60668,
	"./icon/mobile.svg": 99014,
	"./icon/nord-js.svg": 28321,
	"./icon/notification.svg": 63965,
	"./icon/online-course-icon.svg": 10537,
	"./icon/online-course-img.svg": 58535,
	"./icon/online-student-icon.svg": 43943,
	"./icon/paypal-icon.svg": 64569,
	"./icon/people.svg": 80049,
	"./icon/php-course-icon.svg": 5232,
	"./icon/php.svg": 72664,
	"./icon/plane-icon.svg": 63464,
	"./icon/play-01.svg": 93758,
	"./icon/play-icon.svg": 3912,
	"./icon/play.svg": 72494,
	"./icon/python.svg": 27526,
	"./icon/react.svg": 3149,
	"./icon/search-icon.svg": 90542,
	"./icon/sign-right-arrow.svg": 12782,
	"./icon/smile.svg": 33524,
	"./icon/smily.svg": 51232,
	"./icon/student-icon.svg": 70117,
	"./icon/student.svg": 34065,
	"./icon/swift.svg": 57145,
	"./icon/teacher.svg": 28394,
	"./icon/time.svg": 323,
	"./icon/timer-icon.svg": 30655,
	"./icon/timer-start.svg": 2248,
	"./icon/timer.svg": 12635,
	"./icon/twitter-x-icon.svg": 52136,
	"./icon/user-graduate-icon.svg": 73361,
	"./icon/user-icon.svg": 61989,
	"./icon/users.svg": 5600,
	"./icon/video.svg": 13617,
	"./icon/voice.svg": 77094,
	"./icon/winning.svg": 90283,
	"./icon/wish.svg": 66037,
	"./image 25.jpg": 8070,
	"./impressive-dev-img.png": 53419,
	"./inner-banner.jpg": 49375,
	"./instructor-img-1.png": 39945,
	"./instructor-img-2.png": 91762,
	"./instructor-img-3.png": 13307,
	"./instructor-img-4.png": 58500,
	"./instructor-img-5.png": 21741,
	"./instructor-profile-bg.jpg": 92413,
	"./instructor/address-icon.png": 46496,
	"./instructor/courses-icon.png": 33366,
	"./instructor/email-icon.png": 33584,
	"./instructor/instructor-01.jpg": 40275,
	"./instructor/instructor-02.jpg": 46116,
	"./instructor/instructor-03.jpg": 24161,
	"./instructor/instructor-04.jpg": 98674,
	"./instructor/instructor-bg-banner--.png": 4870,
	"./instructor/instructor-bg-banner.png": 6404,
	"./instructor/instructor-course-icon.svg": 59639,
	"./instructor/instructor-reviews-icon.svg": 27287,
	"./instructor/instructor-students-icon.svg": 34254,
	"./instructor/instructor-table-01.jpg": 5926,
	"./instructor/instructor-table-02.jpg": 63697,
	"./instructor/instructor-table-03.jpg": 62791,
	"./instructor/instructor-table-04.jpg": 87135,
	"./instructor/instructor-table-05.jpg": 67138,
	"./instructor/phone-icon.png": 35744,
	"./instructor/profile-avatar.jpg": 24777,
	"./instructor/review-icon.png": 4114,
	"./instructor/ttl-stud-icon.png": 89387,
	"./join.png": 24208,
	"./joing-us-skill.png": 92536,
	"./joing-us.png": 54280,
	"./latest-blog-img-1.jpg": 19272,
	"./latest-blog-img-2.jpg": 69847,
	"./latest-blog-img-3.jpg": 59034,
	"./lead-01.png": 5032,
	"./lead-02.png": 67011,
	"./lead-03.png": 77178,
	"./lead-04.png": 29237,
	"./lead-05.png": 17612,
	"./lead-06.png": 84647,
	"./login-bg.png": 68305,
	"./login-img.png": 55319,
	"./logo-caduceus.png": 34697,
	"./logo.png": 65549,
	"./logo.svg": 67503,
	"./logo/Caduceus.svg": 52515,
	"./logo/Caduceus_elementos_logo_01.png": 54580,
	"./logo/Caduceus_logos.png": 52878,
	"./logo/favicon.ico": 38649,
	"./logo/logo-five.png": 88750,
	"./logo/logo-five.svg": 30892,
	"./logo/logo.png": 89899,
	"./logo/logo.svg": 32811,
	"./male-student-img.png": 50611,
	"./male-with-laptop-img.png": 11915,
	"./master-skill-img-1.png": 39782,
	"./master-skill-img-2.png": 20989,
	"./master-skill-img-3.png": 99860,
	"./net-icon-01.png": 20881,
	"./net-icon-02.png": 99770,
	"./net-icon-03.png": 47523,
	"./net-icon-04.png": 87628,
	"./news-event-img-1.jpg": 51482,
	"./news-event-rounded-img-1.png": 96782,
	"./news-event-rounded-img-2.png": 68581,
	"./news-event-rounded-img-3.png": 39164,
	"./object.png": 19621,
	"./pencil-icon.svg": 72409,
	"./pexels-karolina-grabowska-5207102.jpg": 41887,
	"./plan.png": 39509,
	"./profile-bg.jpg": 71237,
	"./profiles/avatar-01.jpg": 54802,
	"./profiles/avatar-02.jpg": 92605,
	"./profiles/avatar-03.jpg": 24512,
	"./profiles/avatar-04.jpg": 14675,
	"./profiles/avatar-05.jpg": 86262,
	"./profiles/avatar-06.jpg": 62049,
	"./profiles/avatar-07.jpg": 88452,
	"./profiles/avatar-08.jpg": 83607,
	"./profiles/avatar-09.jpg": 31674,
	"./profiles/avatar-10.jpg": 16880,
	"./profiles/avatar-11.jpg": 17805,
	"./profiles/avatar-12.jpg": 88546,
	"./profiles/avatar-13.jpg": 1215,
	"./profiles/img1.png": 32741,
	"./profiles/img2.png": 60942,
	"./profiles/img3.png": 3959,
	"./profiles/img4.png": 28792,
	"./profiles/img5.png": 97057,
	"./profiles/img6.png": 48074,
	"./profiles/profile-01.png": 11530,
	"./profiles/profile-02.png": 60513,
	"./profiles/profile-03.png": 87800,
	"./profiles/profile-04.png": 67415,
	"./profiles/profile-05.png": 77422,
	"./profiles/profile-06.png": 96197,
	"./profiles/profile-07.png": 78684,
	"./profiles/profile-08.png": 58987,
	"./profiles/profile-09.png": 95330,
	"./profiles/profile-10.png": 41083,
	"./profiles/profile-11.png": 73681,
	"./profiles/profile-12.png": 52570,
	"./profiles/profile-13.png": 16675,
	"./profiles/profile-14.png": 40428,
	"./profiles/profile-15.png": 76341,
	"./profiles/profile-16.png": 90590,
	"./profiles/profile-17.png": 43079,
	"./qute-01.png": 96007,
	"./qute.png": 73339,
	"./react-icon.png": 19661,
	"./register-img.png": 99345,
	"./reviews-img-icon.svg": 67767,
	"./reviews-img-two.png": 93414,
	"./right-arrow.svg": 2916,
	"./send-icon.svg": 17042,
	"./service-01.png": 30795,
	"./service-02.png": 77296,
	"./share.png": 43475,
	"./skil-01.png": 87337,
	"./skills/skill-01.jpg": 67662,
	"./skills/skill-02.jpg": 47929,
	"./skills/skill-03.jpg": 77404,
	"./skills/skill-04.jpg": 78951,
	"./skills/skills-01.jpg": 58941,
	"./skills/skills-01.svg": 77515,
	"./skills/skills-02.jpg": 23634,
	"./skills/skills-02.svg": 22328,
	"./skills/skills-03.jpg": 15,
	"./skills/skills-03.svg": 57193,
	"./skills/skills-04.svg": 70950,
	"./slider/home-slider-2.png": 58338,
	"./slider/home-slider.png": 63855,
	"./slider/home-three-banner-1.jpg": 32258,
	"./slider/home-three-banner-20.jpg": 83368,
	"./slider/home-three-banner.jpg": 12571,
	"./slider/home-three-banner2.jpeg": 85510,
	"./slider/slider-01.png": 73375,
	"./slider/slider-02.png": 18724,
	"./small-arrow-img.png": 97233,
	"./small-hat-img.png": 42549,
	"./spheres.png": 12944,
	"./ssmatos2.png": 4864,
	"./ssmattos.png": 34058,
	"./students/award-01.png": 76528,
	"./students/book.svg": 40258,
	"./students/career.png": 74947,
	"./students/certification.png": 53319,
	"./students/empty-wallet-change.svg": 73575,
	"./students/empty-wallet-tick.svg": 90996,
	"./students/learn-anything.png": 49216,
	"./students/loc-icon.svg": 1321,
	"./students/profile-avatar.png": 702,
	"./students/profile-user.svg": 12648,
	"./students/receipt-text.svg": 4005,
	"./students/refer-img1.png": 81636,
	"./students/refer-img10.png": 36286,
	"./students/refer-img2.png": 95199,
	"./students/refer-img3.png": 17110,
	"./students/refer-img4.png": 91369,
	"./students/refer-img5.png": 36544,
	"./students/refer-img6.png": 91579,
	"./students/refer-img7.png": 26226,
	"./students/refer-img8.png": 78229,
	"./students/refer-img9.png": 95340,
	"./students/skill-01.jpg": 72744,
	"./students/skill-02.jpg": 41143,
	"./students/student-01.jpg": 48570,
	"./students/student-02.jpg": 71173,
	"./students/student-03.jpg": 8808,
	"./students/student-04.jpg": 31483,
	"./students/student-05.jpg": 60350,
	"./students/student-06.jpg": 50409,
	"./students/student-07.jpg": 88684,
	"./students/student-08.jpg": 39631,
	"./students/student-09.jpg": 71698,
	"./students/student-10.jpg": 7320,
	"./students/student-11.jpg": 15189,
	"./students/student-12.jpg": 88938,
	"./students/student-bg-banner.png": 24327,
	"./students/ticket-close.svg": 99330,
	"./students/ticket-open.svg": 98782,
	"./students/ticket-total.svg": 32308,
	"./support-bg.png": 28067,
	"./testimonial-background-img-1.png": 10918,
	"./testimonial-background-img-2.png": 14506,
	"./testimonial-img-1.jpg": 35771,
	"./testimonial-img-2.jpg": 92972,
	"./testimonial-img-3.jpg": 31017,
	"./testimonial/testimonial-01.png": 10959,
	"./testimonial/testimonial-02.png": 88500,
	"./testimonial/testimonial-03.png": 9629,
	"./tick-icon.svg": 41353,
	"./top-category-img-1.png": 94170,
	"./top-category-img-2.png": 24337,
	"./top-category-img-3.png": 26472,
	"./top-category-img-4.png": 1639,
	"./top-category-img-5.png": 83326,
	"./top-category-img-6.png": 50677,
	"./trend-bg.png": 61187,
	"./trending-course-img-1.jpg": 60593,
	"./trending-course-img-2.jpg": 28390,
	"./trending-course-img-3.jpg": 18499,
	"./user-bg-01.png": 67817,
	"./user-bg-02.png": 36850,
	"./user-love.jpg": 11156,
	"./user/user-17.jpg": 36534,
	"./user/user.jpg": 8655,
	"./user/user1.jpg": 37826,
	"./user/user10.jpg": 99696,
	"./user/user10.png": 88852,
	"./user/user11.jpg": 43149,
	"./user/user12.jpg": 11010,
	"./user/user13.jpg": 31007,
	"./user/user14.jpg": 29044,
	"./user/user15.jpg": 7569,
	"./user/user16.jpg": 49798,
	"./user/user2.jpg": 7053,
	"./user/user3.jpg": 62160,
	"./user/user4.jpg": 80963,
	"./user/user5.jpg": 90854,
	"./user/user6.jpg": 23057,
	"./user/user7.jpg": 34900,
	"./user/user7.png": 62000,
	"./user/user8.jpg": 3335,
	"./user/user8.png": 81911,
	"./user/user9.jpg": 51946,
	"./user/user9.png": 52686,
	"./vector-green-img.png": 9909,
	"./vector-img-1.png": 22729,
	"./vector-img-2.png": 69381,
	"./vector-img-3.png": 6587,
	"./vector-img-4.png": 42724,
	"./vector-img-5.png": 96621,
	"./video-bg.jpg": 9223,
	"./video-img-01.jpg": 96893,
	"./video.jpg": 67935,
	"./white-dotted.svg": 16902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;